import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GoogleApi } from "../../../api/googleApi";
const initialState = {
  status: false,
  message: "",
  data: {},
  currentRequestId: undefined,
  loading: "idle",
  action: "",
  error: null,
};

export const verifyCaptcha = createAsyncThunk(
  "auth/verifyCaptcha",
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().google;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await GoogleApi.verifyCaptcha(authData);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const googleTwoFactor = createAsyncThunk(
  "auth/googleTwoFactor",
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().google;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await GoogleApi.googleTwoFactor();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const googleConfirmTwoFactor = createAsyncThunk(
  "auth/googleConfirmTwoFactor",
  async (otp, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().google;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await GoogleApi.googleConfirmTwoFactor(otp);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const disableGoogleTwoFactor = createAsyncThunk(
  "auth/disableGoogleTwoFactor",
  async (otp, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().google;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await GoogleApi.disableGoogleTwoFactor(otp);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const validateOauth = createAsyncThunk(
  "auth/validateOauth",
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().google;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await GoogleApi.validateOauth();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const resetGoogleOauth = createAsyncThunk(
  "auth/resetGoogleOauth",
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().google;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = initialState;
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
const googleSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyCaptcha.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "verify_captcha";
        }
      })
      .addCase(verifyCaptcha.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = action.payload;
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(verifyCaptcha.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(googleTwoFactor.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "google_two_factor";
        }
      })
      .addCase(googleTwoFactor.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = action.payload;
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(googleTwoFactor.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(googleConfirmTwoFactor.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "google_confirm_two_factor";
        }
      })
      .addCase(googleConfirmTwoFactor.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = action.payload;
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(googleConfirmTwoFactor.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(disableGoogleTwoFactor.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "google_disable_two_factor";
        }
      })
      .addCase(disableGoogleTwoFactor.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = action.payload;
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(disableGoogleTwoFactor.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(resetGoogleOauth.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "";
        }
      })
      .addCase(resetGoogleOauth.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = {};
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(resetGoogleOauth.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(validateOauth.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "validate_oauth";
        }
      })
      .addCase(validateOauth.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = {
            ...state.data,
            validate_oauth: action.payload.data
              ? action.payload.data
              : action.payload,
          };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(validateOauth.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      });
  },
});

export default googleSlice.reducer;
